import axios from "axios";

import endPoints from "../../../../../config/endPoints";

export const getAllServiceItems = async(deptId, reqBody) => {  
  return await axios.post(`${endPoints.serviceItems}/${deptId}`, reqBody);  
};
